// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonEclipse_wrap__2eXd-","button":"ButtonEclipse_button__5Ryzp"};